'use client';

import { useCommandPalette } from './use-command-palette';
import { CommandPalette, buildDefaultItems } from './command-palette';
import type { NavigationContext } from '@/src/lib/navigation';
import { useTheme } from '@/src/lib/use-theme';

export function AppShellCommandPalette({ availableContexts, permissions }: {
  availableContexts: NavigationContext[];
  permissions: string[];
}) {
  const { isOpen, close } = useCommandPalette();
  const { resolvedTheme, setTheme } = useTheme();
  return isOpen ? <CommandPalette isOpen onClose={close} items={buildDefaultItems({ availableContexts, permissions, onToggleTheme: () => setTheme(resolvedTheme === 'dark' ? 'light' : 'dark') })} /> : null;
}
